const nombrePaciente = (paciente) => {
  return `${paciente?.nombre || ""} ${paciente?.apellidos || ""}`.trim();
};

export const consentTemplates = {

  // =====================================================
  // EXODONCIA
  // =====================================================

  exodoncia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA EXODONCIA DENTAL

Yo, ${nombrePaciente(paciente)}, declaro que el profesional de la salud ${doctor.nombre} me ha explicado de manera clara y suficiente el procedimiento de extracción dental (exodoncia), incluyendo objetivos, beneficios, riesgos, complicaciones, alternativas y cuidados posteriores.

Entiendo que el procedimiento puede incluir:

- extracción simple o quirúrgica
- anestesia local
- osteotomía
- odontosección
- sutura

RIESGOS Y COMPLICACIONES POSIBLES

- dolor
- inflamación
- sangrado
- infección
- alveolitis
- trismus
- parestesia temporal o permanente
- lesión a dientes vecinos
- fractura radicular
- comunicación oroantral
- necesidad de procedimientos adicionales

También se me informó que ningún procedimiento médico u odontológico garantiza resultados absolutos.

ALTERNATIVAS DE TRATAMIENTO

- observación clínica
- tratamiento restaurador
- endodoncia
- cirugía especializada
- no realizar tratamiento

Declaro haber informado correctamente mis antecedentes médicos, alergias, medicamentos y enfermedades sistémicas.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo de manera libre y voluntaria la realización del procedimiento.

`,

  // =====================================================
  // ENDODONCIA
  // =====================================================

  endodoncia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA ENDODONCIA

Yo, ${nombrePaciente(paciente)}, declaro haber recibido información suficiente respecto al tratamiento de conductos.

Comprendo que el tratamiento tiene como objetivo eliminar infección y preservar el órgano dental.

RIESGOS POSIBLES

- dolor postoperatorio
- fractura dental
- persistencia de infección
- necesidad de retratamiento
- perforación
- separación de instrumentos
- necesidad de extracción

ALTERNATIVAS

- extracción dental
- observación
- tratamiento restaurador

Entiendo que el éxito del tratamiento no puede garantizarse al 100%.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo voluntariamente la realización del procedimiento.

`,

  // =====================================================
  // ORTODONCIA
  // =====================================================

  ortodoncia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA ORTODONCIA

Yo, ${nombrePaciente(paciente)}, declaro haber recibido explicación suficiente sobre el tratamiento de ortodoncia.

Entiendo que los objetivos incluyen:

- alineación dental
- corrección de mordida
- mejoría funcional y estética

RIESGOS Y EFECTOS POSIBLES

- dolor o molestia
- reabsorción radicular
- caries
- gingivitis
- enfermedad periodontal
- recidiva
- movilidad dental
- ulceraciones
- cambios en ATM

La duración del tratamiento es estimada y puede variar según respuesta biológica y cooperación del paciente.

Entiendo que la cooperación del paciente es fundamental para el éxito del tratamiento.

Autorizo la toma de fotografías, radiografías y modelos digitales con fines diagnósticos y clínicos.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

`,

  // =====================================================
  // IMPLANTES
  // =====================================================

  implantes: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA IMPLANTES DENTALES

Yo, ${nombrePaciente(paciente)}, declaro haber recibido información suficiente sobre la colocación de implantes dentales.

Comprendo que el procedimiento incluye:

- cirugía de colocación
- anestesia local
- integración ósea
- restauración protésica

RIESGOS POSIBLES

- fracaso del implante
- infección
- dolor
- inflamación
- sangrado
- pérdida ósea
- lesión nerviosa
- sinusitis
- necesidad de injerto óseo

También comprendo que factores como:

- tabaquismo
- diabetes
- higiene deficiente

pueden afectar el éxito del tratamiento.

Comprendo que puede existir necesidad de procedimientos complementarios.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo voluntariamente la realización del procedimiento.

`,

  // =====================================================
  // OPERATORIA
  // =====================================================

  operatoria: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA TRATAMIENTOS DE OPERATORIA DENTAL

Yo, ${nombrePaciente(paciente)}, autorizo procedimientos de operatoria dental restauradora, incluyendo eliminación de caries, resinas, reconstrucciones, incrustaciones y tratamientos relacionados.

Entiendo que durante el tratamiento pueden presentarse molestias, sensibilidad dental, fracturas, inflamación o necesidad de tratamientos adicionales.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} a realizar el procedimiento correspondiente bajo criterios profesionales y conforme a la normatividad mexicana vigente.

`,

  // =====================================================
  // PERIODONCIA
  // =====================================================

  periodoncia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA TRATAMIENTO PERIODONTAL

Yo, ${nombrePaciente(paciente)}, declaro que se me ha explicado que padezco afecciones periodontales que pueden comprometer encía, hueso y estructuras de soporte dental.

Autorizo procedimientos como:

- raspado y alisado radicular
- curetajes
- cirugía periodontal
- control de placa
- mantenimiento periodontal

Entiendo los riesgos, limitaciones y posibles complicaciones.

Reconozco que el éxito del tratamiento depende también de mi higiene oral y seguimiento clínico.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} a realizar el tratamiento periodontal correspondiente.

`,

  // =====================================================
  // ODONTOLOGÍA INTEGRAL
  // =====================================================

  odontologiaIntegral: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA TRATAMIENTO DE ODONTOLOGÍA INTEGRAL

Yo, ${nombrePaciente(paciente)}, autorizo la realización de procedimientos diagnósticos y terapéuticos necesarios para mi atención odontológica integral.

Comprendo que el plan de tratamiento puede incluir procedimientos de:

- operatoria
- periodoncia
- endodoncia
- rehabilitación
- cirugía
- profilaxis
- radiografías
- anestesia local

Se me han explicado riesgos, beneficios y alternativas terapéuticas.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Acepto continuar con el tratamiento bajo supervisión profesional de ${doctor.nombre}.

`,

  // =====================================================
  // PROSTODONCIA
  // =====================================================

  prostodoncia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA TRATAMIENTO PROSTODÓNCICO

Yo, ${nombrePaciente(paciente)}, autorizo la realización de tratamientos prostodónticos como:

- coronas
- puentes
- prótesis removibles
- prótesis totales
- rehabilitación oral

Entiendo que pueden existir ajustes, molestias temporales, cambios funcionales y necesidad de controles posteriores.

Comprendo que ninguna prótesis garantiza duración permanente y que el éxito depende del cuidado, higiene y mantenimiento adecuado.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} a realizar el tratamiento indicado.

`,

  // =====================================================
  // PROFILAXIS
  // =====================================================

  profilaxis: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA PROFILAXIS DENTAL

Yo, ${nombrePaciente(paciente)}, autorizo la realización de profilaxis, limpieza dental y eliminación de cálculo.

Entiendo que puede existir sensibilidad temporal, sangrado gingival o molestias leves.

Reconozco la importancia del mantenimiento preventivo y controles periódicos.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} a realizar el procedimiento.

`,

  // =====================================================
  // RADIOGRAFÍAS
  // =====================================================

  radiografias: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA ESTUDIOS RADIOGRÁFICOS

Yo, ${nombrePaciente(paciente)}, autorizo la toma de estudios radiográficos necesarios para diagnóstico y tratamiento dental.

Se me explicó que la exposición a radiación se encuentra dentro de límites diagnósticos aceptados, siguiendo protocolos de seguridad.

Declaro haber informado si existe embarazo o sospecha del mismo.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} la realización de dichos estudios.

`,

  // =====================================================
  // ANESTESIA LOCAL
  // =====================================================

  anestesia: ({
    paciente,
    doctor
  }) => `

CONSENTIMIENTO INFORMADO PARA ANESTESIA LOCAL

Yo, ${nombrePaciente(paciente)}, autorizo la aplicación de anestesia local para procedimientos odontológicos.

Comprendo posibles efectos secundarios:

- dolor temporal
- inflamación
- hematoma
- alergias
- parestesia
- reacción medicamentosa

En casos excepcionales pueden presentarse emergencias médicas impredecibles.

He informado mis antecedentes médicos y alergias conocidas.

Declaro haber tenido oportunidad de realizar preguntas y que todas mis dudas fueron aclaradas satisfactoriamente.

Comprendo que puedo revocar este consentimiento antes del procedimiento.

Este consentimiento forma parte del expediente clínico odontológico.

Autorizo a ${doctor.nombre} a aplicar anestesia local cuando sea clínicamente necesario.

`
};